<template>
  <div
    class="-locate -action"
    @click.stop="$emit('locate')"
    v-tooltip="tooltipOptions"
    :class="{ '-disabled-btn': !asset._isInTimeline }"
  >
    <span class="wticon wticon-magnifier"></span>
  </div>
</template>

<script>
export default {
  name: 'AssetRemove',
  props: {
    asset: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      locations: [],
    };
  },
  computed: {
    tooltipOptions() {
      return {
        title: this.asset._isInTimeline ? 'Locate on timeline' : 'Unused',
        placement: 'top auto',
        wrapperClass: 'dark',
        delay: { show: 250, hide: 0 },
        container: '.tooltip-container',
      };
    },
  },
  watch: {},
};
</script>

<style scoped>
.-disabled-btn {
  cursor: default !important;
  .wticon {
    opacity: 0.5;
  }
}
</style>
